// extracted by mini-css-extract-plugin
export var attachButton = "_ci-8";
export var sendButton = "_ci-2";
export var sendDisabled = "_ci-4";
export var sendEnabled = "_ci-3";
export var sendIcon = "_ci-6";
export var sendIconDisabled = "_ci-7";
export var sendStreaming = "_ci-5";
export var textarea = "_ci-1";
export var wrapper = "_ci-0";